import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Base from "./Base";
var Warning = function Warning(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Base, {
    type: "warning"
  }, children);
};
Warning.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
export default /*#__PURE__*/memo(Warning);